<script setup lang="ts">
import TheHeader from '@/components/organisms/TheHeader/TheHeader.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const useTransparentTheme = computed(() => route.meta.useTransparentLayout as boolean)
</script>
<template>
    <TheHeader
        :useWhiteLogo="useTransparentTheme"
        :class="useTransparentTheme ? 'header--transparent' : ''"
    />
    <ErrorMessage />
    <main
        class="container-fluid main"
        :class="useTransparentTheme ? 'main--transparent' : ''"
    >
        <slot></slot>
    </main>
</template>

<style lang="scss" scoped>
.main {
   // background: $white;

    &--transparent {
        background-color: transparent;
        position: relative;
    }
}


</style>
